// =============================================================================
// Usage:
// ------------------------------------
//
// initMusicPlayer( [ album_list ]. [ track_list ] );
//
// =============================================================================
// Usage Example 1 ( Using Track List Only ):
// ------------------------------------
//
// initMusicPlayer(
//   [
//     {
//       name: 'Track Name',
//       duration: '0:00', // does not have to be filled
//       description: '', // does not have to be filled
//       albumInfo: // set to `albumInfo: {},` if not using
//       {
//         artist: 'Artist Name',
//         name: 'Album Name',
//         releaseDate: '2021',
//         image: '/path/to/album_image.png', // can be an external link
//         audioRoot: '/path/to/album'
//       },
//       albumIndex: -1, // overrides `albumInfo` if greater than or equal to 0
//       // overrides `albumInfo` and `albumIndex` if filled:
//       artist: '',
//       album: '',
//       releaseDate: '',
//       image: '/path/to/album_image.png', // can be an external link
//       audioRoot: '/path/to/album',
//       fileMp3: 'file_name.mp3', // gets added to `audioRoot`
//       fileOgg: 'file_name.ogg', // gets added to `audioRoot`
//       fileName: 'file_name', // overrides `fileMp3`, `fileOgg`; gets added to `audioRoot`
//       pathMp3: '', // overrides `file*` and `fileName` variables; can be an external link
//       pathOgg: '' // overrides `file*` and `fileName` variables; can be an external link
//     }
//   ]
// );
//
// Usage Example 2 ( Using Album List to Save Space ):
// ------------------------------------
//
// setMusicPlayerAlbumList(
//   [
//     {
//       artist: 'Artist Name',
//       name: 'Album Name',
//       releaseDate: '2021',
//       image: '/path/to/album_image.png', // can be an external link
//       audioRoot: '/path/to/album'
//     }
//   ]
// );
//
// setMusicPlayerTrackList(
//   [
//     {
//       name: 'Track Name',
//       duration: '0:00', // does not have to be filled
//       description: '', // does not have to be filled
//       albumInfo: {}, // set to `albumInfo: {},` if not using
//       albumIndex: 0, // overrides `albumInfo` if greater than or equal to 0
//       // overrides `albumInfo` and `albumIndex` if filled:
//       artist: '',
//       album: '',
//       releaseDate: '',
//       image: '/path/to/album_image.png', // can be an external link
//       audioRoot: '/path/to/album',
//       fileMp3: 'file_name.mp3', // gets added to `audioRoot`
//       fileOgg: 'file_name.ogg', // gets added to `audioRoot`
//       fileName: 'file_name', // overrides `fileMp3`, `fileOgg`; gets added to `audioRoot`
//       pathMp3: '', // overrides `file*` and `fileName` variables; can be an external link
//       pathOgg: '' // overrides `file*` and `fileName` variables; can be an external link
//     }
//   ]
// );
//
// initMusicPlayer();

import * as Event from './../../_function/event.js';
import * as ModuleClass from './../../_function/class.js';
import * as Number from './../../_function/number.js';
import * as Element from './../../_function/element.js';

// =============================================================================
// Music Player Elements

// let now_playing = document.querySelector('.musicplayer__now-playing');
let musicplayer        = document.querySelector('.musicplayer');
let details            = document.querySelector('.musicplayer__details');
let details_right      = document.querySelector('.musicplayer__details__right');

// let track_art          = document.querySelector('.musicplayer__coverart');
let track_art_default  = document.querySelector('#musicplayer__coverart__placeholder');
let track_name         = document.querySelector('.musicplayer__track-title');
let track_album        = document.querySelector('.musicplayer__track-album');
let track_artist       = document.querySelector('.musicplayer__track-artist');
let track_release_date = document.querySelector('.musicplayer__track-release_date');

let controls           = document.querySelector('.musicplayer__controls');
let playpause_btn      = document.querySelector('.musicplayer__button--playpause');
let next_btn           = document.querySelector('.musicplayer__button--next');
let prev_btn           = document.querySelector('.musicplayer__button--previous');
let vol_left           = document.querySelector('.musicplayer__volume--left');
let vol_right          = document.querySelector('.musicplayer__volume--right');

let shuffle_btn        = document.querySelector('.musicplayer__button--shuffle');
let repeat_btn         = document.querySelector('.musicplayer__button--repeat');

let seek_slider        = document.querySelector('.seek_slider');
let volume_slider      = document.querySelector('.volume_slider');
let time_current       = document.querySelector('.time-current');
// let total_duration     = document.querySelector('.total-duration');
let time_remaining     = document.querySelector('.time-remaining');

let tracklist          = document.querySelector('.musicplayer__tracklist');
let descriptions       = document.querySelector('.musicplayer__descriptions-list');

// var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
// var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
// if ( iOS ) ModuleClass.addClass(musicplayer, 'musicplayer--iOS');
// var isMobile = navigator.userAgent.toLowerCase().match(/mobile/i),
//     isTablet = navigator.userAgent.toLowerCase().match(/tablet/i),
//     isAndroid = navigator.userAgent.toLowerCase().match(/android/i),
//     isiPhone = navigator.userAgent.toLowerCase().match(/iphone/i),
//     isiPad = navigator.userAgent.toLowerCase().match(/ipad/i);
// if ( isiPhone || isiPad ) ModuleClass.addClass(musicplayer, 'musicplayer--iOS');
// var isMobile = navigator.userAgent.toLowerCase().match(/mobile/i);
// if ( isMobile ) ModuleClass.addClass(musicplayer, 'musicplayer--iOS');
// var nav = window.navigator;
// var ua = nav.userAgent;
// function isiOsSafari (a) {
// 	return ("standalone" in nav) // There's a thing called standalone in nav
// 	 && !nav.standalone // It is not running in standalone mode
// 	 && ua.indexOf(a)!=-1 // iPhone is in the UA string (could be Opera)
// 	 && ua.indexOf('Mac OS')!=-1 // There's Mac in the UA string (not Opera)
// 	 && ua.indexOf('Safari')!=-1
// }
// if(isiOsSafari('iPhone') || isiOsSafari('iPad')) {
//   ModuleClass.addClass(musicplayer, 'musicplayer--iOS');
// }
// if(/iP(ad|hone|od).+Version\/[\d\.]+.*Safari/i.test(navigator.userAgent)) {
//   ModuleClass.addClass(musicplayer, 'musicplayer--iOS');
// }
let isIOS = ( /iPad|iPhone|iPod/.test( navigator.platform ) ||
  ( navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 ) ) &&
  !window.MSStream;
if ( isIOS ) {
  ModuleClass.addClass(musicplayer, 'musicplayer--iOS');
}

// =============================================================================
// Music Player Visualizer

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-webaudio-setclasses !*/
!function(n,e,o){function s(n,e){return typeof n===e}function a(){var n,e,o,a,i,l,r;for(var c in f)if(f.hasOwnProperty(c)){if(n=[],e=f[c],e.name&&(n.push(e.name.toLowerCase()),e.options&&e.options.aliases&&e.options.aliases.length))for(o=0;o<e.options.aliases.length;o++)n.push(e.options.aliases[o].toLowerCase());for(a=s(e.fn,"function")?e.fn():e.fn,i=0;i<n.length;i++)l=n[i],r=l.split("."),1===r.length?Modernizr[r[0]]=a:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=a),t.push((a?"":"no-")+r.join("-"))}}function i(n){var e=r.className,o=Modernizr._config.classPrefix||"";if(c&&(e=e.baseVal),Modernizr._config.enableJSClass){var s=new RegExp("(^|\\s)"+o+"no-js(\\s|$)");e=e.replace(s,"$1"+o+"js$2")}Modernizr._config.enableClasses&&(e+=" "+o+n.join(" "+o),c?r.className.baseVal=e:r.className=e)}var t=[],f=[],l={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(n,e){var o=this;setTimeout(function(){e(o[n])},0)},addTest:function(n,e,o){f.push({name:n,fn:e,options:o})},addAsyncTest:function(n){f.push({name:null,fn:n})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var r=e.documentElement,c="svg"===r.nodeName.toLowerCase();Modernizr.addTest("webaudio",function(){var e="webkitAudioContext"in n,o="AudioContext"in n;return Modernizr._config.usePrefixes?e||o:o}),a(),i(t),delete l.addTest,delete l.addAsyncTest;for(var u=0;u<Modernizr._q.length;u++)Modernizr._q[u]();n.Modernizr=Modernizr}(window,document);

var visualizerOptions = {
  enabled: true,
  debug: false,
  barCount: 50, // range = 1 -> 100
  barHeightType: 0, // 0 = max, 1 = min, 2 = average
  barPadding: 1,
  barPaddingType: 0, // 0 = pixels, 1 = percentage
		barColor: 'rgba(224, 173, 87, 0.86)',
  barBackground: 1,
  barBackgroundColor: 'rgba(255, 255, 255, 0.06)',
  framesPerSecond: 20 // range = 1 -> 60
};

// var visualizerEnabled = true;
// // var visualizerEnabled = false;
// var visualizerBarCount = 50; // range = 1 -> 100
// var visualizerBarHeightType = 0; // 0 = max, 1 = min, 2 = average
// var visualizerBarPadding = 1;
// var visualizerBarPaddingType = 0; // 0 = pixels, 1 = percentage
// // var visualizerBarColor = '#0CF';
// // var visualizerBarColor = '#FFF';
	// var visualizerBarColor = 'rgba(224, 173, 87, 0.86)';
// var visualizerBarBackground = 1;
// // var visualizerBarBackgroundColor = '#FFF1';
// var visualizerBarBackgroundColor = 'rgba(255, 255, 255, 0.06)';
// var visualizerFramesPerSecond = 30; // range = 1 -> 60

// var visualizerFrequencyCount = visualizerBarCount;
// var visualizerFrequencyCount = 1028;
var visualizerFrequencyCount = isIOS ? 512 : 128; // Must be a better way to detect max frquency range for source on first frame
// ^ sampleRate is also 4x larger on desktop than mobile, possible connection?
var visualizerInited = false;
var visualizerActivated = false;
var visualizerStopQueued = false;

var visualizerAudioContext;
var visualizerAudioContextSource;
var visualizerAnalyser;
var visualizerCanvasActive;
var visualizerCanvasActiveContext;

var visualizerLoopTimer;
var visualizerFrameMillis;

var visualizerDebugElement;

function visualizerDebug( detail ) {
  if ( !visualizerActivated || !visualizerOptions.debug ) return;

  if ( !visualizerDebugElement )
  {
    visualizerDebugElement = document.createElement( 'div' );
    ModuleClass.addClass( visualizerDebugElement, 'musicplayer__visualizer-debug' );

    Element.insertElementAfter( visualizerDebugElement, track_release_date );
  }

  // setting sampleRate does not work in any browser:
  // visualizerAudioContext.sampleRate = 41000;
  // visualizerAudioContext.sampleRate = 192000;

  debugstring = '[ ' + detail + ' ] ';

  debugstring += 'rate ' + visualizerAudioContext.sampleRate + ', ';
  // sampleRates:
  //   PC Firefox = 192000
  //   PC Edge = 192000
  //   PC Chrome = 192000
  //   iOS Headphones = 44100 // issues in iOS only
  //   iOS Speaker = 48000 // issues in iOS only
  //   Android S10e Speaker = 48000
  //   Android S10e Headphones = 48000

  visualizerDebugElement.innerHTML = debugstring;
}

function visualizerLoadOptions( options ) {
  if ( options ) visualizerOptions = options;

  // Pre-calculate Reusable Variables
  visualizerFrameMillis = 1000 / Math.min( Math.max( visualizerOptions.framesPerSecond, 1 ), 60 );
  visualizerOptions.barCount = Math.min( Math.max( visualizerOptions.barCount, 1 ), visualizerFrequencyCount );
}

function visualizerInit( options ) {
  if ( ModuleClass.hasClass( document.getElementsByTagName('html')[0], 'no-webaudio' ) || isIOS ) return;

  visualizerLoadOptions( options );

  if ( !visualizerOptions.enabled ) return;

  let visualizerElement = document.createElement( 'div' );
  ModuleClass.addClass( visualizerElement, 'musicplayer__visualizer' );

  let visualizerCanvasContainer = Element.addElement( visualizerElement, 'div', '', 'musicplayer__visualizer__canvas-container' );

  if ( visualizerOptions.barBackground )
  {
    let visualizerCanvasBackground = Element.addElement( visualizerCanvasContainer, 'canvas', '', [ 'musicplayer__visualizer__canvas', 'musicplayer__visualizer__canvas--background' ] );

    window.requestAnimationFrame( function () {
      visualizerRenderFrame( visualizerCanvasBackground, visualizerCanvasBackground.getContext( '2d' ), true );
    } );
  }

  visualizerCanvasActive = Element.addElement( visualizerCanvasContainer, 'canvas', '', [ 'musicplayer__visualizer__canvas', 'musicplayer__visualizer__canvas--active' ] );

  Element.insertElementAfter( visualizerElement, details_right );

	visualizerCanvasActiveContext = visualizerCanvasActive.getContext( '2d' );

  ModuleClass.addClass( musicplayer, 'visualizer' );
  Element.insertElementAfter( controls, details );

  visualizerInited = true;
}

function visualizerActivate() {
  if ( !visualizerInited || !visualizerOptions.enabled || visualizerActivated ) return;

  try {
    visualizerAudioContext = new ( window.AudioContext || window.webkitAudioContext )(); // AudioContext object instance
  }
  catch(e) {
    console.log('Web Audio API is not supported in this browser');
    return;
  }

  console.log('Web Audio API is not supported in this browser');
  if ( !visualizerAudioContext ) return;

	visualizerAnalyser = visualizerAudioContext.createAnalyser(); // AnalyserNode method

  console.log('Web Audio API Analyser is not supported in this browser');
  if ( !visualizerAnalyser ) return;

	// Re-route audio playback into the processing graph of the AudioContext
	visualizerAudioContextSource = visualizerAudioContext.createMediaElementSource( curr_track );
	visualizerAudioContextSource.connect( visualizerAnalyser );

  console.log('Web Audio API Context Source is not supported in this browser');
  if ( !visualizerAudioContextSource ) return;

	visualizerAnalyser.connect( visualizerAudioContext.destination );

  visualizerActivated = true;
}

let visualizerFrequencies = null;

function visualizerSyncCanvasSize( targetCanvas ) {
  const canvasBounds = targetCanvas.getBoundingClientRect();
  const pixelRatio = window.devicePixelRatio || 1;
  const canvasWidth = Math.max( 1, Math.round( canvasBounds.width * pixelRatio ) );
  const canvasHeight = Math.max( 1, Math.round( canvasBounds.height * pixelRatio ) );

  if ( targetCanvas.width !== canvasWidth ) targetCanvas.width = canvasWidth;
  if ( targetCanvas.height !== canvasHeight ) targetCanvas.height = canvasHeight;
}

function visualizerRenderFrame( targetCanvas, targetCanvasContext, isBackground ) {
  visualizerSyncCanvasSize( targetCanvas );

  if ( !isBackground )
  {
    // visualizerAnalyser.fftSize = visualizerOptions.barCount * 2;
    visualizerFrequencies = new Uint8Array( visualizerAnalyser.frequencyBinCount );
    visualizerAnalyser.getByteFrequencyData( visualizerFrequencies );
  }
  targetCanvasContext.clearRect( 0, 0, targetCanvas.width, targetCanvas.height ); // Clear the canvas

  targetCanvasContext.fillStyle = isBackground ? visualizerOptions.barBackgroundColor : visualizerOptions.barColor;

  const bar_x_skip = targetCanvas.width / visualizerOptions.barCount;

  let bar_gap = visualizerOptions.barPadding * ( window.devicePixelRatio || 1 );
  switch ( visualizerOptions.barPaddingType ) {
    case 1:
    {
      bar_gap = bar_x_skip * Math.min( Math.max( 1 - visualizerOptions.barPadding, 0 ), 0.9 );
      break;
    }
    case 0: default:
    {
      bar_gap = Math.max( bar_gap, bar_x_skip * 0.08 );
      break;
    }
  }
  bar_gap = Math.min( bar_gap, bar_x_skip * 0.45 );
  const bar_width = ( targetCanvas.width - ( bar_gap * ( visualizerOptions.barCount - 1 ) ) ) / visualizerOptions.barCount;

  var local_cluster_size = parseInt( visualizerFrequencyCount / visualizerOptions.barCount );

  var bar_height_total = 0;

	for (var i = 0; i < visualizerOptions.barCount; i++) {
    const bar_x = i * ( bar_width + bar_gap );

    if ( isBackground )
    {
      targetCanvasContext.fillRect( bar_x, targetCanvas.height, bar_width, -targetCanvas.height );
    }
    else
    {
      let bar_height = 0;

      if ( visualizerOptions.barCount == visualizerFrequencyCount )
      {
        bar_height = visualizerFrequencies[ i ];
      }
      else {
        switch ( visualizerOptions.barHeightType ) {
          case 1:
          {
            local_min = 0;
            for ( var j = 0; j < local_cluster_size; j++ )
            {
              local_min = Math.min( local_min , visualizerFrequencies[ ( i * local_cluster_size ) + j ] );
            }
            bar_height = local_min;
            break;
          }
          case 2:
          {
            local_average = 0;

            for ( var j = 0; j < local_cluster_size; j++ )
            {
              local_average = local_average + visualizerFrequencies[ ( i * local_cluster_size ) + j ];
            }
            local_average = local_average / local_cluster_size;
		bar_height = local_average;
            break;
          }
          case 0: default:
          {
            let local_max = 0;
            for (var j = 0; j < local_cluster_size; j++)
            {
              local_max = Math.max( local_max , visualizerFrequencies[ ( i * local_cluster_size ) + j ] );
            }
            bar_height = local_max;
            break;
          }
        }
      }

      if ( bar_height )
      {
	    // targetCanvasContext.fillRect( parseInt( bar_x ), parseInt( targetCanvas.height ), parseInt( bar_width ), parseInt( -1 * targetCanvas.height * ( bar_height / 255 ) ) );
	    targetCanvasContext.fillRect( bar_x, targetCanvas.height, bar_width, -targetCanvas.height * ( bar_height / 255 ) );

        if ( visualizerStopQueued )
        {
          bar_height_total = bar_height_total + bar_height;
        }
      }
    }
	}

  if ( visualizerStopQueued && !bar_height_total )
  {
    visualizerStop();
  }
}

function visualizerStop() {
  clearTimeout( visualizerLoopTimer );
  visualizerStopQueued = false;
}

function visualizerRenderFrameActive() {
  visualizerRenderFrame( visualizerCanvasActive, visualizerCanvasActiveContext, false );
}

function visualizerRenderFrameLoop() {
  window.requestAnimationFrame( visualizerRenderFrameActive );

  clearTimeout( visualizerLoopTimer );

  visualizerLoopTimer = setTimeout( visualizerRenderFrameLoop, visualizerFrameMillis );
}

function visualizerQueueStart() {
  if ( !visualizerActivated ) return;

  if ( visualizerStopQueued )
  {
    visualizerStopQueued = false;

    if ( visualizerLoopTimer ) return;
  }

  visualizerRenderFrameLoop();
  visualizerDebug('start');
}

function visualizerQueueStop() {
  if ( !visualizerActivated ) return;

  // if ( !visualizerLoopTimer ) visualizerRenderFrameLoop(); // allow any remaining bars to dissappear
  visualizerStopQueued = true;
}

// =============================================================================
// Music Player

var track_index = -1;
var track_duration = 0;
let isPlaying = false;
let updateTimer;

// Create new audio element
let curr_track = document.createElement('audio');

// Update remaining time as soon as possible:
curr_track.onloadeddata = function() { seekUpdate(); };

// Move to the next track if the current one finishes playing:
curr_track.addEventListener('ended', endedTrack);

let album_list = [
  {
    artist: 'Artist Name',
    name: 'Album Name',
    releaseDate: '2021',
    image: '/path/to/album_image.png', // can be an external link
    audioRoot: '/path/to/album'
  }
];

// Define the tracks that have to be played
let track_list = [
  {
    name: 'Track Name',
    duration: '0:00', // does not have to be filled
    description: '', // does not have to be filled
    albumInfo: // set to `albumInfo: {},` if not using
    {
      artist: 'Artist Name',
      name: 'Album Name',
      releaseDate: '2021',
      image: '/path/to/album_image.png', // can be an external link
      audioRoot: '/path/to/album'
    },
    albumIndex: -1, // overrides `albumInfo` if greater than or equal to 0
    // overrides `albumInfo` and `albumIndex` if filled:
    artist: '',
    album: '',
    releaseDate: '',
    image: '/path/to/album_image.png', // can be an external link
    audioRoot: '/path/to/album',
    fileMp3: 'file_name.mp3', // gets added to `audioRoot`
    fileOgg: 'file_name.ogg', // gets added to `audioRoot`
    fileName: 'file_name', // overrides `fileMp3`, `fileOgg`; gets added to `audioRoot`
    pathMp3: '', // overrides `fileMp3`, `fileOgg`, `fileName`; can be an external link
    pathOgg: '' // overrides `fileMp3`, `fileOgg`, `fileName`; can be an external link
  }
];

const pswpGallery = document.querySelector('#musicplayer__coverart__gallery.pswp-gallery');
const pswpGalleryImage = pswpGallery?.querySelector('a.pswp-gallery__item');
const pswpGalleryImgTag = pswpGalleryImage?.querySelector('img');
// const pswpGalleryCaption = pswpGallery?.querySelector('.pswp-gallery figcaption');

function setAlbumArtVisibility(show) {
  track_art_default.style.opacity = show ? '0' : '1';
  if (pswpGallery) pswpGallery.style.display = show ? '' : 'none';
}

// Hide both by default
setAlbumArtVisibility(false);

function loadTrack( track_index_new, direction ) {
  if ( !( repeat_tracks == 1 ) && track_index_new == track_index ) return;

  updateLists( track_index_new, track_index );
  updateHistory( track_index_new, direction );

  track_index = track_index_new;

  clearInterval( updateTimer );
  resetValues();

  let albumIndex = track_list[ track_index ].albumIndex;
  let albumData = ( albumIndex >= 0 ? album_list[ albumIndex ] : track_list[ track_index ].albumInfo ) || {};
  let current_audioRoot = track_list[ track_index ].audioRoot || albumData.audioRoot;

  // let m4aFile = track_list[ track_index ].pathM4a || ( current_audioRoot + '/' + ( track_list[ track_index ].fileName ? ( track_list[ track_index ].fileName + '.m4a' ) : track_list[ track_index ].fileM4a ) );
  let mp3File = track_list[ track_index ].pathMp3 || ( current_audioRoot + '/' + ( track_list[ track_index ].fileName ? ( track_list[ track_index ].fileName + '.mp3' ) : track_list[ track_index ].fileMp3 ) );
  let oggFile = track_list[ track_index ].pathOgg || ( current_audioRoot + '/' + ( track_list[ track_index ].fileName ? ( track_list[ track_index ].fileName + '.ogg' ) : track_list[ track_index ].fileOgg ) );

  // Load a new track

  // if ( curr_track.canPlayType('audio/mp4') && m4aFile )
  //   curr_track.src = m4aFile;
  // else
  if ( curr_track.canPlayType('audio/mpeg') && mp3File )
  // if ( mp3File && !(!!(curr_track.canPlayType) && ("no" != curr_track.canPlayType("audio/mpeg")) && ("" != curr_track.canPlayType("audio/mpeg"))) )
    curr_track.src = mp3File;
  else if ( curr_track.canPlayType('audio/ogg') && oggFile )
  // else if ( oggFile && !(!!(curr_track.canPlayType) && ("no" != curr_track.canPlayType("audio/ogg")) && ("" != curr_track.canPlayType("audio/ogg"))) )
    curr_track.src = oggFile;
  else return;

  curr_track.load();

  // Update details of the track
  let trackImage = track_list[ track_index ].image || albumData.image;
  let info_track_name = track_list[ track_index ].name || '';
  let info_track_album = track_list[ track_index ].album || albumData.name || '';
  let info_track_artist = track_list[ track_index ].artist || albumData.artist || '';
  let info_track_releaseDate = track_list[ track_index ].releaseDate || albumData.releaseDate || '';

  track_name.innerHTML = info_track_name;
  track_artist.innerHTML = info_track_artist;
  track_album.innerHTML = info_track_album;
  // track_art.style.backgroundImage = trackImage ? 'url(' + trackImage + ')' : '';
  track_release_date.innerHTML = info_track_releaseDate;

  // Update gallery image to match current album art
  if (trackImage && pswpGalleryImage && pswpGalleryImgTag) {
    const testImg = new Image();
    testImg.onload = function () {
      // Only show elements if the image actually loads
      pswpGalleryImage.href = trackImage;
      pswpGalleryImgTag.src = trackImage;

      // Show the gallery
      setAlbumArtVisibility(true);

      // Update figcaption to show "Artist – Album Cover Art"
      // pswpGalleryImgTag.alt = `${info_track_artist} – ${info_track_album} Cover Art`;
      // if (pswpGalleryCaption) {
      //   pswpGalleryCaption.textContent = `${info_track_artist} – ${info_track_album} Cover Art`;
      // }
    };
    testImg.onerror = function () {
      // Keep fallback visible if image fails to load
      setAlbumArtVisibility(false);
    };
    testImg.src = trackImage;
  }

  if ('mediaSession' in navigator) {
    navigator.mediaSession.metadata = new MediaMetadata({
      title: info_track_name,
      artist: info_track_artist,
      album: info_track_album,
      artwork: [
        { src: trackImage, sizes: '96x96', type: 'image/png' },
        { src: trackImage, sizes: '128x128', type: 'image/png' },
        { src: trackImage, sizes: '192x192', type: 'image/png' },
        { src: trackImage, sizes: '256x256', type: 'image/png' },
        { src: trackImage, sizes: '384x384', type: 'image/png' },
        { src: trackImage, sizes: '512x512', type: 'image/png' },
      ]
    });

    // navigator.mediaSession.setActionHandler('play', playTrack);
    // navigator.mediaSession.setActionHandler('pause', pauseTrack);
    // navigator.mediaSession.setActionHandler('previoustrack', prevTrack);
    // navigator.mediaSession.setActionHandler('nexttrack', nextTrack);
    // navigator.mediaSession.setActionHandler('seekto', function(details) {
    //   handleSeekTo(details.seekTime);
    // });
  }

  if ( isPlaying ) playTrack();
}

// Reset Values
function resetValues() {
  resetSeekPreview();
  time_current.textContent = '00:00';
  // total_duration.textContent = '00:00';
  time_remaining.textContent = '00:00';
  seek_slider.value = 0;
  updateSeekSliderBackground();
}

function playpauseTrack() {
  if (!isPlaying) playTrack();
  else pauseTrack();
}

function playTrack() {
  curr_track.play();
  isPlaying = true;
  ModuleClass.addClass( musicplayer, 'musicplayer--playing' );

  // Set an interval of 1000 milliseconds for updating the seek slider
  updateTimer = setInterval( seekUpdate, 1000 );

  // Replace icon with the pause icon
  ModuleClass.removeClass( playpause_btn, 'musicplayer__button--playpause--paused' );
  ModuleClass.addClass( playpause_btn, 'musicplayer__button--playpause--playing' );
  playpause_btn.title = 'Pause Track';

  if ( !visualizerActivated ) visualizerActivate();
  visualizerQueueStart();

  // Update media session playback state
  if ('mediaSession' in navigator) {
    navigator.mediaSession.playbackState = 'playing';
  }
}

function pauseTrack() {
  curr_track.pause();
  isPlaying = false;
  ModuleClass.removeClass( musicplayer, 'musicplayer--playing' );

  clearInterval( updateTimer );

  // Replace icon with the play icon
  ModuleClass.removeClass( playpause_btn, 'musicplayer__button--playpause--playing' );
  ModuleClass.addClass( playpause_btn, 'musicplayer__button--playpause--paused' );
  playpause_btn.title = 'Play Track';

  visualizerQueueStop();

  // Update media session playback state
  if ('mediaSession' in navigator) {
    navigator.mediaSession.playbackState = 'paused';
  }
}

var shuffleArray = [];
// var shuffleArrayHistory = [];
// var shuffleArrayHistoryPos = 0;
var hasShuffledArray = false;

function resetShuffleArray() {
  if ( shuffleArray.length ) shuffleArray = [];
  // if ( shuffleArrayHistory.length ) shuffleArrayHistory = [];
  // if ( shuffleArrayHistoryPos ) shuffleArrayHistoryPos = 0;
  hasShuffledArray = false;
}

let wantsPause = false;

function verifyShuffleArray() {
  if ( !shuffleArray.length )
  {
    if ( hasShuffledArray && !repeat_tracks )
    {
      wantsPause = true;
      hasShuffledArray = false;
    }
    else
    {
      for ( var i = 0; i < track_list.length; i++ )
        if(i != track_index) shuffleArray[shuffleArray.length] = i;

      hasShuffledArray = true;
    }
  }
  // console.log(shuffleArray.length);
  // console.log(hasShuffledArray);

  return wantsPause;
}

// function pushShuffleArrayHistoryLeft( track_index_new ) {
//   shuffleArrayHistory.unshift( track_index_new );
//   shuffleArrayHistoryPos = 0;
// }
//
// function pushShuffleArrayHistoryRight( track_index_new ) {
//   shuffleArrayHistory[shuffleArrayHistory.length] = track_index_new;
//   shuffleArrayHistoryPos = shuffleArrayHistory.length - 1;
// }

function getShuffleArraySelection() {
  var track_index_new = track_index;

  var shuffleArraySelection = Number.randomNumberInRange(0, shuffleArray.length - 1);

  track_index_new = shuffleArray[shuffleArraySelection];

  shuffleArray.splice(shuffleArraySelection, 1);

  return track_index_new;
}

// function traverseShuffleArrayHistoryLeft() {
// }
//
// function traverseShuffleArrayHistoryRight() {
// }

function updateHistory( track_index_new, direction ) {
}

function nextTrack( ended ) {
  // if ( track_list.length == 1 && isPlaying ) {
  if ( track_list.length == 1 ) {
    curr_track.currentTime = 0;
    resetValues();
    seekUpdate();
    // curr_track.play();

    if ( ended )
    {
      if ( !repeat_tracks )
      {
        pauseTrack();
      }
      else
      {
        playTrack();
      }
    }
  }
  else
  {
    var track_index_new = track_index;

    wantsPause = false;

    if ( !shuffle_tracks )
    {
      resetShuffleArray();

      if (track_index_new < track_list.length - 1) track_index_new += 1;
      else
      {
        track_index_new = 0;
        // endOfList = true;
      }

      if ( !repeat_tracks && ended && track_index_new == 0 )
        wantsPause = true;
    }
    else
    {
      // if ( shuffleArrayHistoryPos < shuffleArrayHistory.length )
      // {
      //   if (shuffleArrayHistoryPos < shuffleArrayHistory.length - 1) shuffleArrayHistoryPos += 1;
      //   else shuffleArrayHistoryPos = 0;
      //
      //   track_index_new = shuffleArrayHistory[shuffleArrayHistoryPos];
      // }
      // else
      // {

        // if ( !shuffleArray.length )
        // {
        //   if ( hasShuffledArray && !repeat_tracks )
        //   {
        //     wantsPause = true;
        //     hasShuffledArray = false;
        //   }
        //   else
        //   {
        //     for ( var i = 0; i < track_list.length; i++ )
        //       if(i != track_index) shuffleArray[shuffleArray.length] = i;
        //
        //     hasShuffledArray = true;
        //   }
        // }

        wantsPause = verifyShuffleArray();

        if ( wantsPause ) track_index_new = 0;
        else
        {
          // if ( !shuffleArrayHistory.length ) pushShuffleArrayHistoryRight( track_index_new );

          // var shuffleArraySelection = Number.randomNumberInRange(0, shuffleArray.length - 1);
          //
          // track_index_new = shuffleArray[shuffleArraySelection];
          //
          // shuffleArray.splice(shuffleArraySelection, 1);

          track_index_new = getShuffleArraySelection();

          // pushShuffleArrayHistoryRight( track_index_new );
        }
      // }

      // console.log(shuffleArrayHistory);
      // console.log(shuffleArrayHistoryPos);
    }

    if ( wantsPause ) pauseTrack();
    loadTrack( track_index_new );
  }
}

function endedTrack() {
  if ( repeat_tracks == 2 )
  {
    curr_track.currentTime = 0;
    curr_track.play();
  }
  else
  {
    nextTrack( true );
  }
}

function prevTrack() {
  if ( curr_track.currentTime > 3 ) {
    curr_track.currentTime = 0;
    resetValues();
    seekUpdate();
    // curr_track.play();
  }
  else
  {
    var track_index_new = track_index;

    if ( !shuffle_tracks )
    {
      // if ( shuffle_tracks && shuffleArrayHistory.length )
      // {
      //   track_index_new = shuffleArrayHistory[shuffleArrayHistoryPos - 1];
      //
      //   if (shuffleArrayHistoryPos > 0) shuffleArrayHistoryPos -= 1;
      //   else shuffleArrayHistoryPos = shuffleArrayHistoryPos.length - 1;
      // }
      // else {
        if (track_index_new > 0) track_index_new -= 1;
        else track_index_new = track_list.length - 1;
      // }
    }
    else
    {
      var wantsPause = verifyShuffleArray();

      if ( wantsPause ) track_index_new = 0;
      else
      {
        // if ( !shuffleArrayHistory.length ) pushShuffleArrayHistoryLeft( track_index_new );

        // var shuffleArraySelection = Number.randomNumberInRange(0, shuffleArray.length - 1);
        //
        // track_index_new = shuffleArray[shuffleArraySelection];
        //
        // shuffleArray.splice(shuffleArraySelection, 1);

        track_index_new = getShuffleArraySelection();

        // pushShuffleArrayHistoryLeft( track_index_new );

        // console.log(shuffleArrayHistory);
        // console.log(shuffleArrayHistoryPos);
      }
    }

    if ( wantsPause ) pauseTrack();
    loadTrack(track_index_new);
  }
}

let repeat_tracks = 0;
let shuffle_tracks = false;

function repeatTracks() {
  if (repeat_tracks < 2) repeat_tracks += 1;
  else repeat_tracks = 0;

  switch(repeat_tracks)
  {
    case 0: default:
    {
      ModuleClass.addClass(repeat_btn, 'musicplayer__button--repeat--disabled');
      ModuleClass.removeClass(repeat_btn, 'musicplayer__button--repeat--track');
      repeat_btn.title = 'Turn On Album Repeating';
      resetShuffleArray(); // make sure we do one more full "rotation" before ending, prevent ending "too soon"
      break;
    }
    case 1:
    {
      ModuleClass.removeClass(repeat_btn, 'musicplayer__button--repeat--disabled');
      ModuleClass.removeClass(repeat_btn, 'musicplayer__button--repeat--track');
      repeat_btn.title = 'Turn On Track Repeating';
      break;
    }
    case 2:
    {
      ModuleClass.removeClass(repeat_btn, 'musicplayer__button--repeat--disabled');
      ModuleClass.addClass(repeat_btn, 'musicplayer__button--repeat--track');
      repeat_btn.title = 'Turn Off Track Repeating';
      break;
    }
  }
}
function shuffleTracks() {
  shuffle_tracks = !shuffle_tracks;

  if ( shuffle_tracks )
  {
    ModuleClass.removeClass(shuffle_btn, 'musicplayer__button--shuffle--disabled');
    shuffle_btn.title = 'Turn Off Track Shuffling';
  }
  else
  {
    ModuleClass.addClass(shuffle_btn, 'musicplayer__button--shuffle--disabled');
    shuffle_btn.title = 'Turn On Track Shuffling';
  }
}

let isPreviewing = false;

let sliderMax = 1000;

function updateSeekSliderBackground() {
  seek_slider.dispatchEvent(inputEventSliderBackground);
}

function resetSeekPreview() {
  isPreviewing = false;
  previewTime = null;
}

function getFiniteTrackDuration() {
  return globalThis.Number.isFinite(curr_track.duration) && curr_track.duration > 0 ? curr_track.duration : 0;
}

function getFiniteTrackTime() {
  return globalThis.Number.isFinite(curr_track.currentTime) && curr_track.currentTime > 0 ? curr_track.currentTime : 0;
}

function formatTrackTime(time) {
  time = globalThis.Number.isFinite(time) && time > 0 ? time : 0;

  let minutes = Math.floor(time / 60);
  let seconds = Math.floor(time - minutes * 60);

  if (minutes < 10) minutes = '0' + minutes;
  if (seconds < 10) seconds = '0' + seconds;

  return minutes + ':' + seconds;
}

function setSeekPosition(timePosition, duration) {
  duration = globalThis.Number.isFinite(duration) && duration > 0 ? duration : 0;
  timePosition = globalThis.Number.isFinite(timePosition) && timePosition > 0 ? timePosition : 0;

  if (duration) timePosition = Math.min(timePosition, duration);

  const sliderValue = duration ? (timePosition / duration) * sliderMax : 0;
  seek_slider.value = Math.min(Math.max(sliderValue, 0), sliderMax);
  updateSeekSliderBackground();
}

function getSeekTime() {
  const duration = getFiniteTrackDuration();

  if (!duration) return 0;

  return duration * (seek_slider.value / sliderMax);
}

function seekTo() {
  resetSeekPreview();
  curr_track.currentTime = getSeekTime();

  seekUpdate();
  visualizerDebug( "seek" );
}

let previewTime = null;

function seekPreview() {
  isPreviewing = true;
  previewTime = getSeekTime();
  seekUpdate( previewTime );
}

const inputEventSliderBackground = new CustomEvent('updateSliderBackground', { bubbles: true, cancelable: true });

function seekUpdate( seekPreviewTime ) {
  if ( !isPlaying && updateTimer ) clearInterval( updateTimer );
  // if ( !isPlaying && time_remaining.textContent != '00:00' ) clearInterval( updateTimer );

  if ( seekPreviewTime == null && isPreviewing ) return;

  const duration = getFiniteTrackDuration();
  const timePosition = seekPreviewTime == null ? getFiniteTrackTime() : seekPreviewTime;

  setSeekPosition( timePosition, duration );

  if ( !duration ) {
    time_current.textContent = formatTrackTime( 0 );
    // total_duration.textContent = formatTrackTime( 0 );
    time_remaining.textContent = formatTrackTime( 0 );
    return;
  }

  const clampedTimePosition = Math.min( Math.max( timePosition, 0 ), duration );

  time_current.textContent = formatTrackTime( clampedTimePosition );
  // total_duration.textContent = formatTrackTime( duration );
  time_remaining.textContent = '-' + formatTrackTime( duration - clampedTimePosition );
}

function setVolume() {
  var vol = volume_slider.value;
  curr_track.volume = vol / sliderMax;
  volume_slider.dispatchEvent(inputEventSliderBackground);

  if ( vol == 0 )
  {
    ModuleClass.addClass(vol_right, 'musicplayer__volume--off');
    ModuleClass.removeClass(vol_right, 'musicplayer__volume--low');
    ModuleClass.removeClass(vol_right, 'musicplayer__volume--medium');
    ModuleClass.removeClass(vol_right, 'musicplayer__volume--full');

    ModuleClass.addClass(vol_left, 'musicplayer__volume--muted');
  }
  else
  {
    ModuleClass.removeClass(vol_left, 'musicplayer__volume--muted');

    if ( vol < sliderMax * 0.5 )
    {
      ModuleClass.removeClass(vol_right, 'musicplayer__volume--off');
      ModuleClass.addClass(vol_right, 'musicplayer__volume--low');
      ModuleClass.removeClass(vol_right, 'musicplayer__volume--medium');
      ModuleClass.removeClass(vol_right, 'musicplayer__volume--full');
    }
    else if ( vol < sliderMax )
    {
      ModuleClass.removeClass(vol_right, 'musicplayer__volume--off');
      ModuleClass.removeClass(vol_right, 'musicplayer__volume--low');
      ModuleClass.addClass(vol_right, 'musicplayer__volume--medium');
      ModuleClass.removeClass(vol_right, 'musicplayer__volume--full');
    }
    else
    {
      ModuleClass.removeClass(vol_right, 'musicplayer__volume--off');
      ModuleClass.removeClass(vol_right, 'musicplayer__volume--low');
      ModuleClass.removeClass(vol_right, 'musicplayer__volume--medium');
      ModuleClass.addClass(vol_right, 'musicplayer__volume--full');
    }
  }
}

function muteVolume() {
  volume_slider.value = 0;
  setVolume();
}
function maximizeVolume() {
  volume_slider.value = sliderMax;
  setVolume();
}

window.trackButton = function( track_index_new ) {
  if ( track_index_new == track_index )
  {
    playpauseTrack();
  }
  else
  {
    loadTrack( track_index_new )
  }
}

let tracklistArray = [];
let descriptionlistArray = [];

function populate_lists()
{
  for ( var i = 0; i < track_list.length; i++ )
  {
    tracklistArray[i] = Element.addElement( tracklist, 'li', '', '', '<a class="button" href="#" onclick="trackButton(' + i + '); return false;"><span class="musicplayer__tracklist__duration">' + track_list[i].duration + '</span><span class="musicplayer__tracklist__number"><span class="musicplayer__tracklist__number__indicator"><span class="musicplayer__tracklist__number__indicator__inner"><span class="font-icon--module-music-player--musicbar" aria-hidden="true"></span><span class="font-icon--module-music-player--musicbar" aria-hidden="true"></span><span class="font-icon--module-music-player--musicbar" aria-hidden="true"></span></span></span>' + ( i + 1 ) + '</span> ' + track_list[i].name + '</a>' );

    if ( descriptions )
    {
      let description = track_list[i].description;

      if ( description )
      {
        descriptionlistArray[i] = Element.addElement( descriptions, 'li', '', '', ( i + 1 ) + '. <span class="musicplayer__tracklist__description-title"><b>' + track_list[i].name + '</b>&nbsp; <span class="musicplayer__descriptionlist_duration">( ' + track_list[i].duration + ' )&nbsp;</span> </span><hr><div>' + description + '</div>' );
        descriptionlistArray[i].value = i + 1;
      }
      else
      {
        descriptionlistArray[i] = '';
      }
    }
    else
    {
      descriptionlistArray[i] = '';
    }
  }
}

function updateLists(current, prev) {
  if ( current != prev )
  {
    ModuleClass.addClass(tracklistArray[current], 'selected');
    if ( prev > -1 ) ModuleClass.removeClass(tracklistArray[prev], 'selected');

    if ( descriptionlistArray[current] != '' ) {
      ModuleClass.addClass(descriptionlistArray[current], 'selected');
    }
    if ( descriptionlistArray[prev] != '' ) {
      if ( prev > -1 ) ModuleClass.removeClass(descriptionlistArray[prev], 'selected');
    }
  }
}

function setMusicPlayerAlbumList( albumList ) {
  album_list = albumList;
}

function setMusicPlayerTrackList( trackList ) {
  track_list = trackList;
}

function handleSeekTo(seekTime) {
  curr_track.currentTime = seekTime;
  seekUpdate();
}

window.musicPlayerInit = function( albumList, trackList, visualizerOptions ) {
  if ( albumList ) setMusicPlayerAlbumList( albumList );

  if ( trackList ) setMusicPlayerTrackList( trackList );

  populate_lists();

  // Load the first track in the tracklist
  loadTrack( 0 );

  if ('mediaSession' in navigator) {
    navigator.mediaSession.setActionHandler('play', playTrack);
    navigator.mediaSession.setActionHandler('pause', pauseTrack);
    navigator.mediaSession.setActionHandler('previoustrack', prevTrack);
    navigator.mediaSession.setActionHandler('nexttrack', nextTrack);
    navigator.mediaSession.setActionHandler('seekto', function(details) { handleSeekTo(details.seekTime); });
  }

  visualizerInit( visualizerOptions );
}

const musicplayer__input_shuffleTracks  = document.getElementById('musicplayer__input-shuffle-tracks');
const musicplayer__input_repeatTracks   = document.getElementById('musicplayer__input-repeat-tracks');
const musicplayer__input_prevTrack      = document.getElementById('musicplayer__input-prev-track');
const musicplayer__input_playpauseTrack = document.getElementById('musicplayer__input-playpause-track');
const musicplayer__input_nextTrack      = document.getElementById('musicplayer__input-next-track');
const musicplayer__input_muteVolume     = document.getElementById('musicplayer__input-mute-volume');
const musicplayer__input_maximizeVolume = document.getElementById('musicplayer__input-maximize-volume');
const musicplayer__input_seek           = document.getElementById('musicplayer__input-seek');
const musicplayer__input_volume         = document.getElementById('musicplayer__input-volume');

Event.addEvent( 'click',  musicplayer__input_shuffleTracks,  shuffleTracks );
Event.addEvent( 'click',  musicplayer__input_repeatTracks,   repeatTracks );
Event.addEvent( 'click',  musicplayer__input_prevTrack,      prevTrack );
Event.addEvent( 'click',  musicplayer__input_playpauseTrack, playpauseTrack );
Event.addEvent( 'click',  musicplayer__input_nextTrack,      nextTrack );
Event.addEvent( 'click',  musicplayer__input_muteVolume,     muteVolume );
Event.addEvent( 'click',  musicplayer__input_maximizeVolume, maximizeVolume );
Event.addEvent( 'input',  musicplayer__input_seek,           seekPreview );
Event.addEvent( 'change', musicplayer__input_seek,           seekTo );
Event.addEvent( 'input',  musicplayer__input_volume,         setVolume );
